const searchToggle = document.querySelector('.search__toggle');
const searchForm = document.querySelector('.search__form');
const searchField = document.querySelector('.search__field');
if(searchField) {
  const searchFieldID = searchField.getAttribute('id');
}

const navigation = document.querySelector('.header__navigation');

if(searchToggle) {
  searchToggle.addEventListener('click', (e)=> {
  e.preventDefault();
  if (!searchToggle.classList.contains('is-open')) {
    searchToggle.classList.add('is-open');
    searchForm.classList.add('is-open');
    const openedSubMenu = document.querySelector('.megamenu__container.is-open');
    if( openedSubMenu ) {
      openedSubMenu.classList.remove('is-open');
    }
    navigation.classList.add('search-open');
    document.getElementById(searchFieldID).focus();
  } else {
    searchToggle.classList.remove('is-open');
    searchForm.classList.remove('is-open');
    navigation.classList.remove('search-open');
  }
});
}



// WEBPACK FOOTER //
// ./scripts/util/toggleSearch.js